import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';
import { ArrowLeftIcon } from '@change/ds-icons';

import { usePageBreadcrumbData } from './hooks';

export const PageBreadcrumb: React.FC = () => {
	const { data, actions } = usePageBreadcrumbData();

	return (
		<div className="p-4 md:px-8 md:py-5">
			<div className="flex flex-row items-center gap-2.5">
				<Link
					className="sm:pt-0 md:pt-1"
					href={data.dashboardLink}
					data-qa="dashboard-breadcrumb-link"
					onClick={actions.dashboardLinkClicked}
					variant="secondary"
					aria-label="corgi.petition.edit.dashboard_breadcrumb"
				>
					<ArrowLeftIcon size="large" className="hidden md:block" />
					<ArrowLeftIcon className="block md:hidden" />
				</Link>
				<Text variant="heading" className="sm:text-size-heading-xs md:text-size-heading-small">
					Edit petition
				</Text>
			</div>
		</div>
	);
};
